import { makeWebchatVisitorsRepository } from 'modules/webchat/infra/repositories';

import IdentifyWebchatVisitorUseCase from './implementations/IdentifyWebchatVisitorUseCase';

let instance: IdentifyWebchatVisitorUseCase | null = null;

export default function makeIdentifyWebchatVisitorUseCase() {
  if (!instance) {
    instance = new IdentifyWebchatVisitorUseCase(
      makeWebchatVisitorsRepository(),
    );
  }

  return instance;
}
